import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Footer from "components/Footer";
import PATHS from "utils/paths";
import { getAppUserCapabilities } from "utils/mapStateToProps";
import { capabilityFlags } from "utils/capability";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import { ENV } from "utils/constants/env";
import { ApplicationContextProvider } from "utils/context";
import { BUTTON_TAGS } from "utils/constants/ui";
import { isServer } from "utils/view";
import Button from "components/Form/fields/Button";
import { magicCheckoutStyles } from "components/Landing/MagicCheckout/magicCheckoutStyles";
import dynamic from "next/dynamic";
import QRCodeEditorLoader from "components/QRCodeEditorLoader";
import { fetchAppBuilder, fetchAppCheckout } from "actions/app";
import { fetchMockUserDetails, fetchUserDetails } from "actions/auth";
import { fetchMerchantAccountTaxRates } from "actions/taxRate";
import { fetchMerchantAccountShippingRates } from "actions/shippingRate";
import {
  fetchMerchantAccountProductsPrices,
  fetchMerchantAccountCouponsPromotionCodes
} from "actions/merchantAccount";
import { ensureUnauthInit } from "utils/hooks/unauth";

const QRCodeEditorContainer = dynamic(
  () => import("components/QRCodeEditorContainer"),
  {
    ssr: false,
    loading: QRCodeEditorLoader
  }
);

const MarketingContactless = ({ shortLink, actions }) => {
  const { loading, application, merchantAccount } = ensureUnauthInit({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices,
    fetchMerchantAccountCouponsPromotionCodes:
      actions.fetchMerchantAccountCouponsPromotionCodes,
    fetchMerchantAccountTaxRates: actions.fetchMerchantAccountTaxRates,
    fetchMerchantAccountShippingRates:
      actions.fetchMerchantAccountShippingRates,
    fetchAppCheckout: actions.fetchAppCheckout,
    fetchAppBuilder: actions.fetchAppBuilder,
    fetchUserDetails: actions.fetchUserDetails,
    fetchMockUserDetails: actions.fetchMockUserDetails
  });

  const tryButtonProps = {
    tag: BUTTON_TAGS.LINK,
    href: PATHS.FEATURES_LINKS_BUILDER,
    copy: "Try demo",
    classes: {
      button:
        "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
    }
  };

  const heroProps = {
    header: [
      {
        copy: "Accept payments with"
      },
      {
        copy: "branded",
        classes: "color-primary underline"
      },
      {
        copy: "QR codes."
      }
    ],
    subheader:
      "Design a custom QR code for any payment link. Checkout is just a scan away.",
    action: tryButtonProps
  };

  return (
    <ApplicationContextProvider
      application={application}
      merchantAccount={merchantAccount}
      env={ENV.TEST}
    >
      <div className="w-100 relative">
        <div className="mw8 center">
          <HeroBanner {...heroProps} />
        </div>
        <div className="w-100 relative bt bb hairline-1">
          <div className="dn dn-m flex-ns flex-row absolute top-0 left-0 right-0 bottom-0 overflow-hidden">
            <div className="w-50 bg-off-white-ns"></div>
            <div className="w-50 split__container-ns bg-white"></div>
          </div>
          {shortLink && (
            <div className="pv4">
              <QRCodeEditorContainer shortLink={shortLink} loading={loading} />
            </div>
          )}
        </div>
        <div className="w-100 before__image magic_checkout_link_bg relative">
          <div className="w-100 relative mw8 center pt5 pt1-l pb5">
            <div className="w-100 flex items-center justify-center">
              <div className="flex flex-column justify-center">
                <div className="fw6 tc dib bg-white center f3 f2-l pb2 ph3 ph0-l">
                  Build a link, design a code
                </div>
                <div className="tc dib bg-white center f5 pb2 lh-copy ph3 ph0-l">
                  Try our link builder to see how easy it is to get started with
                  QR code payments.
                </div>
              </div>
            </div>
            {!isServer() && (
              <div className="flex flex-column flex-row-ns items-center justify-center pt3">
                <div className="pb3 pb0-ns">
                  <Button {...tryButtonProps} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="mw8 center pt5-l">
          <div className="pt5 hairline-1 bt">
            <Footer />
          </div>
        </div>
        <style jsx>{landingStyles}</style>
        <style jsx>{magicCheckoutStyles}</style>
      </div>
    </ApplicationContextProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    flags: capabilityFlags(getAppUserCapabilities(state))
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchAppBuilder,
      fetchAppCheckout,
      fetchUserDetails,
      fetchMockUserDetails,
      fetchMerchantAccountProductsPrices,
      fetchMerchantAccountCouponsPromotionCodes,
      fetchMerchantAccountTaxRates,
      fetchMerchantAccountShippingRates
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingContactless);
